import { render, staticRenderFns } from "./ProfitDistribution.vue?vue&type=template&id=6bc6018c&scoped=true"
import script from "./ProfitDistribution.vue?vue&type=script&lang=js"
export * from "./ProfitDistribution.vue?vue&type=script&lang=js"
import style0 from "./ProfitDistribution.vue?vue&type=style&index=0&id=6bc6018c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6018c",
  null
  
)

export default component.exports